
document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-mobile-toggle]');
  if (!button) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.hasAttribute('hidden');
  if (open) menu.removeAttribute('hidden');
  else menu.setAttribute('hidden', '');
  button.setAttribute('aria-expanded', String(open));
});
